import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IEventEnrollment } from '../store';
import { IEventsActionResponse } from '../Utils/TEventsActionResponse';

export const withdraw = async (state: IStore, eventId: number): Promise<IEventsActionResponse> => {
  const enrollmentId = state.events[eventId].enrollment.id;
  const response = await request.patch(`${api.eventRegistration}${enrollmentId}/`, {
    status: 'canceled'
  });
  const enrollmentIndex = state.events[eventId].enrollments.findIndex(
    (element: any) => element.id === enrollmentId
  );
  const enrollments = state.events[eventId].enrollments;

  if (response.error) {
    return { errors: { events: { msg: 'Error withdrawing from Event.' } } };
  }
  const enrollment: IEventEnrollment = response;
  const event = state.events[eventId];
  const updatedEnrollment = { ...event.enrollments[enrollmentIndex], ...enrollment };
  enrollments[enrollmentIndex] = updatedEnrollment;
  return {
    events: {
      ...state.events,
      [eventId]: {
        ...event,
        enrollment,
        enrollments
      }
    }
  };
};
